type EventListener = () => void;

export class Timer {
    private duration: number; // Duration in seconds
    private remainingTime: number;
    private timerInterval: NodeJS.Timeout | null = null;
    public isRunning: boolean = false;
    private displayElement: HTMLElement;
    private eventListeners: { [event: string]: EventListener[] } = {};

    constructor(initialDuration: number = 5*60) {
        this.displayElement = document.getElementById('timer')!;
        this.duration = initialDuration; // Default to 8 minutes (480 seconds)
        this.remainingTime = this.duration;
        this.updateDisplay();
    }

    private updateDisplay() {
        this.displayElement.textContent = this.formatTime(this.remainingTime);
    }

    private formatTime(time: number): string {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    private getCurrentTime(): number {
        return this.remainingTime;
    }

    setDuration(newDuration: number) {
        this.duration = newDuration;
        this.remainingTime = this.duration;
        if (this.isRunning) {
            this.reset();
            this.start();
        } else {
            this.updateDisplay();
        }
    }

    start() {
        if (this.isRunning) return;
        
        this.timerInterval = setInterval(() => {
            this.remainingTime--;
            this.updateDisplay();
            if (this.remainingTime <= 0) {
                this.stop();
                //alert("Time's up!");
                this.emit('finish');
            }
        }, 1000);
        this.isRunning = true;
    }

    pause() {
        if (!this.isRunning) return;
        if (this.timerInterval !== null) {
            clearInterval(this.timerInterval);
        }
        this.isRunning = false;
    }

    resume() {
        if (this.isRunning) return;
        this.start();
    }

    reset() {
        if (this.isRunning) {
            this.pause();
        }
        this.remainingTime = this.duration;
        this.updateDisplay();
    }

    stop() {
        if (this.timerInterval !== null) {
            clearInterval(this.timerInterval);
        }
        this.isRunning = false;
    }

    getTime(): string {
        return this.formatTime(this.remainingTime);
    }

    // Event handling methods
    on(event: string, listener: EventListener) {
        if (!this.eventListeners[event]) {
            this.eventListeners[event] = [];
        }
        this.eventListeners[event].push(listener);
    }

    private emit(event: string) {
        if (this.eventListeners[event]) {
            this.eventListeners[event].forEach(listener => listener());
        }
    }
}
